import ErrorResponse from './ErrorResponse'

/**
 * Delayed processing error.
 */
export default class ErrorDelayedProcessing extends ErrorResponse { }
